<svg fill="none" height="20" viewBox="0 0 10 20" width="10" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1 1.66667L9 10.3333L1 19"
    stroke="#009DD6"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
  />
</svg>
